import { render, staticRenderFns } from "./UserOrderPaid.vue?vue&type=template&id=6c96bca6&"
import script from "./UserOrderPaid.vue?vue&type=script&lang=js&"
export * from "./UserOrderPaid.vue?vue&type=script&lang=js&"
import style0 from "./css/common.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports